var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FEE6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.75 8.25H14.25C10.5221 8.25 7.5 11.2721 7.5 15L7.5 18.75C7.5 20.4069 8.84315 21.75 10.5 21.75H15.75C19.4779 21.75 22.5 18.7279 22.5 15C22.5 11.2721 19.4779 8.25 15.75 8.25Z",
    fill: "#DE8D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4375 16.5C11.4375 16.8107 11.6893 17.0625 12 17.0625H15C15.3107 17.0625 15.5625 16.8107 15.5625 16.5C15.5625 16.1893 15.3107 15.9375 15 15.9375H12C11.6893 15.9375 11.4375 16.1893 11.4375 16.5ZM11.4375 13.5C11.4375 13.8107 11.6893 14.0625 12 14.0625L18 14.0625C18.3107 14.0625 18.5625 13.8107 18.5625 13.5C18.5625 13.1893 18.3107 12.9375 18 12.9375L12 12.9375C11.6893 12.9375 11.4375 13.1893 11.4375 13.5Z",
    fill: "#DE8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuContact);
export default __webpack_public_path__ + "static/media/menu_contact.7a93b2d2d45f3312c7232b209db307f3.svg";
export { ForwardRef as ReactComponent };